import React, { useState } from "react";
import { toast } from "sonner";
import { ArrowDown, ArrowUp, Link2, Plus, Trash2, Upload } from "lucide-react";
import { formatErr } from "../../lib/api";
import { uploadTestFile } from "../../lib/testLibrary";
import { btn } from "../leads/PriorityBadge";
import { MediaView } from "./MediaView";

const small = { ...btn("transparent"), padding: "4px 8px", fontSize: 11 };

const StepRow = ({ s, i, n, onChange, onMove, onRemove }) => {
  const [busy, setBusy] = useState(null);
  const upload = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    try { const r = await uploadTestFile(f, "step_media", setBusy); onChange({ ...s, media: [...s.media, { kind: "file", file_id: r.id, media_type: r.media_type, name: r.name }] }); toast.success("Archivo añadido"); }
    catch (err) { toast.error(formatErr(err)); } finally { setBusy(null); }
  };
  const link = () => {
    const url = window.prompt("Pega el enlace (YouTube, imagen o vídeo)");
    if (!url) return;
    onChange({ ...s, media: [...s.media, { kind: "link", url, media_type: /\.(png|jpe?g|webp|gif)(\?|$)/i.test(url) ? "image" : "video" }] });
  };
  return (
    <div style={{ border: "1px solid rgba(255,255,255,0.08)", padding: 10, marginBottom: 8 }} data-testid={`tl-step-${i}`}>
      <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
        <b style={{ minWidth: 22, paddingTop: 8 }}>{i + 1}.</b>
        <textarea className="qv-input" value={s.text} onChange={(e) => onChange({ ...s, text: e.target.value })} style={{ minHeight: 52, textTransform: "none", flex: 1 }} placeholder="Describe este paso" data-testid={`tl-step-text-${i}`} />
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <button style={small} disabled={i === 0} onClick={() => onMove(-1)} data-testid={`tl-step-up-${i}`}><ArrowUp size={12} /></button>
          <button style={small} disabled={i === n - 1} onClick={() => onMove(1)} data-testid={`tl-step-down-${i}`}><ArrowDown size={12} /></button>
          <button style={small} onClick={onRemove} data-testid={`tl-step-remove-${i}`}><Trash2 size={12} /></button>
        </div>
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", margin: "8px 0 0 30px" }}>
        {s.media.map((m, j) => (
          <div key={j} style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-start" }}>
            <MediaView m={m} testid={`tl-step-${i}-media-${j}`} />
            <button style={small} onClick={() => onChange({ ...s, media: s.media.filter((_, k) => k !== j) })} data-testid={`tl-step-${i}-media-remove-${j}`}><Trash2 size={12} /></button>
          </div>
        ))}
      </div>
      <div style={{ display: "flex", gap: 6, margin: "8px 0 0 30px" }}>
        <label style={{ ...small, cursor: "pointer" }} data-testid={`tl-step-upload-${i}`}><Upload size={12} /> {busy !== null ? `Subiendo ${busy}%` : "Subir imagen o vídeo"}
          <input type="file" accept="image/*,video/*" onChange={upload} style={{ display: "none" }} disabled={busy !== null} data-testid={`tl-step-file-${i}`} />
        </label>
        <button style={small} onClick={link} data-testid={`tl-step-link-${i}`}><Link2 size={12} /> Pegar enlace</button>
      </div>
    </div>
  );
};

export const StepsEditor = ({ steps, onChange }) => {
  const set = (i, v) => onChange(steps.map((x, j) => (j === i ? v : x)));
  const move = (i, d) => { const a = [...steps]; [a[i], a[i + d]] = [a[i + d], a[i]]; onChange(a); };
  return (
    <div data-testid="tl-steps-editor">
      {steps.map((s, i) => <StepRow key={i} s={s} i={i} n={steps.length} onChange={(v) => set(i, v)} onMove={(d) => move(i, d)} onRemove={() => onChange(steps.filter((_, j) => j !== i))} />)}
      <button style={btn("transparent")} onClick={() => onChange([...steps, { text: "", media: [] }])} data-testid="tl-step-add"><Plus size={14} /> Añadir paso</button>
    </div>
  );
};
